import React, { useEffect, useRef, useCallback, Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import { Grid } from "@material-ui/core";
import dashboard from "./pages/dashboard";
import notfound from "./pages/404";
import connections from "./pages/connections";
import workflows from "./pages/workflows";
import editor from "./pages/editor";
import support from "./pages/support";
import settings from "./pages/settings";
import userProfile from "./pages/profile";
import executions from "./pages/executions"
import { makeStyles } from '@material-ui/core/styles';
import addAuthForm from "./pages/addAuthForm";
import editAppPage from "./pages/appDatabaseEdit";
import page from "./pages/page";
import canvasPlayground from "./pages/canvasPlayground";
import { isCanvasPlaygroundAllowed } from "./utils/canvasPlaygroundAccess";
import appDeveloper from "./pages/appDeveloper";
import appDeveloperAuthentication from "./pages/appDeveloperAuthentication";
import ErrorBoundary from "./components/ErrorBoundary";
import appDeveloperOverview from "./pages/appDeveloperOverview";
import appDeveloperAuthenticationEdit from "./pages/appDeveloperAuthenticationEdit";
import appDeveloperActions from "./pages/appDeveloperActions";
import appDeveloperActionsEdit from "./pages/appDeveloperActionsEdit";
import appDeveloperTriggers from "./pages/appDeveloperTriggers";
import appDeveloperTriggersEdit from "./pages/appDeveloperTriggersEdit";
import appDeveloperNew from "./pages/appDeveloperNew";
import appDeveloperActionsEditInput from "./pages/appDeveloperActionsEditInput";
import appDeveloperActionsEditApi from "./pages/appDeveloperActionsEditApi";
import Shopify from "./pages/shopify";
import ShopifyPostInstall from "./pages/ShopifyPostIntall";
import agents from "./pages/agents";
import agentDetail from "./pages/agentDetail";
import agentTasks from "./pages/agentTasks";
import agentUsage from "./pages/agentUsage";
import agentShareAccept from "./pages/agentShareAccept";
import agentCoreLiveView from "./pages/agentCoreLiveView";
import { NavigationBlockerProvider } from "./contexts/NavigationBlockerContext";

const LazyForm = lazy(() => import("./pages/form"));

const FormRoute = (props) => (
  <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', width: '100vw', backgroundColor: '#F5F7FB' }}>Loading form...</div>}>
    <LazyForm {...props} />
  </Suspense>
);

const AgentListRedirect = () => <Redirect to="/agents" />;
const AgentDetailRedirect = ({ match }) => (
  <Redirect to={`/agents/${match.params.agentId}`} />
);
const AgentTasksRedirect = ({ match }) => (
  <Redirect to={`/agents/${match.params.agentId}/tasks`} />
);

const useStyles = makeStyles({
  container: {
    display: "flex",
    width: "100%",
    minHeight: "100vh",
    flex: 1,
  }
});

function App() {
  const classes = useStyles();
  const confirmRef = useRef(null);
  const getUserConfirmation = useCallback((message, callback) => {
    if (confirmRef.current) confirmRef.current(message, callback);
    else callback(true);
  }, []);

  useEffect(() => {
    var visits = Number(localStorage.getItem('visitCount'));
    var current = Boolean(sessionStorage.getItem('session'));
    
  
    if (!current) {
      visits++;
    }
    
    localStorage.setItem('visitCount', visits);
    sessionStorage.setItem('session', true);
    
    
  
  }, [])

  

  return (
    <ErrorBoundary>
      <Grid container direction="row">
        <NavigationBlockerProvider confirmRef={confirmRef}>
          <Router getUserConfirmation={getUserConfirmation}>
          <div className={classes.container} style={{ width: "100%" }}>
            <Switch>
              <Route exact path="/" component={editor} />
              <Route exact path="/dashboard" component={dashboard} />
              <Route exact path="/shopify" component={Shopify} />
              <Route exact path="/shopify/admin/oauth/redirect_to_install" component={ShopifyPostInstall} />
              <Route exact path="/executions/:execID" component={executions} />
              <Route exact path="/workflows" component={workflows} />
              <Route exact path="/connections" component={connections} />
              <Route exact path="/settings" component={settings} />
              <Route exact path="/support" component={support} />
              <Route exact path="/profile" component={userProfile} />
              <Route exact path="/workflows" component={workflows} />
              <Route exact path="/agents" component={agents} />
              <Route exact path="/agents/usage" component={agentUsage} />
              <Route exact path="/agents/share/:shareToken" component={agentShareAccept} />
              <Route exact path="/agents/:agentId/tasks" component={agentTasks} />
              <Route exact path="/agents/:agentId" component={agentDetail} />
              <Route exact path="/agentcore-live-view" component={agentCoreLiveView} />
              <Route exact path="/agent" component={AgentListRedirect} />
              <Route exact path="/agent/:agentId/tasks" component={AgentTasksRedirect} />
              <Route exact path="/agent/:agentId" component={AgentDetailRedirect} />
              <Route exact path="/addAuthForm" component={addAuthForm} />
              <Route exact path="/editApps" component={appDeveloper}/>
              <Route exact path="/form/:formId" component={FormRoute}/>
              {isCanvasPlaygroundAllowed() ? (
                <Route exact path="/canvas-playground" component={canvasPlayground}/>
              ) : null}
              <Route exact path="/page/:tenantId/:pageSlug" component={page}/>
              <Route exact path="/page/:pageId" component={page}/>
              <Route exact path="/develop/" component={appDeveloper}/>
              <Route exact path="/develop/new" component={appDeveloperNew}/>
              <Route exact path="/develop/:appSlug" component={appDeveloperOverview}/>
              <Route exact path="/develop/:appSlug/authentication" component={appDeveloperAuthentication}/>
              <Route exact path="/develop/:appSlug/authentication/edit" component={appDeveloperAuthenticationEdit}/>
              <Route exact path="/develop/:appSlug/actions" component={appDeveloperActions}/>
              <Route exact path="/develop/:appSlug/actions/:actionKey/settings" component={appDeveloperActionsEdit}/>
              <Route exact path="/develop/:appSlug/actions/:actionKey/input" component={appDeveloperActionsEditInput}/>
              <Route exact path="/develop/:appSlug/actions/:actionKey/input/:id" component={appDeveloperActionsEditInput}/>
              <Route exact path="/develop/:appSlug/actions/:actionKey/api" component={appDeveloperActionsEditApi}/>
              <Route exact path="/develop/:appSlug/triggers" component={appDeveloperTriggers}/>
              <Route exact path="/develop/:appSlug/triggers/:triggerKey/settings" component={appDeveloperTriggersEdit}/>
              <Route exact path="/develop/:appSlug/actions/:triggerKey/input" component={appDeveloperTriggersEdit}/>
              <Route path="/404" component={notfound} />
              <Redirect to="/404" />
            </Switch>
          </div>
          </Router>
        </NavigationBlockerProvider>
        <Grid item xs={12} />
      </Grid>
    </ErrorBoundary>
  );
};

export default App;
